export const production = {
  urlApi: 'https://api.alta-box.com/'
};
